//
export default [
    {
        text: "código interno",
        value: "internal_code",
        width: "15%",
    },
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "cantidad",
        value: "quantity",
        align: "right",
        input: {
            type: "float-field",
            reverse: true,
            trigger(ctx, props) {
                props.item.required = Number(props.item.repacking_factor) * Number(props.item.quantity)
            },
        },
        width: "15%",
    },
    {
        text: "requerido",
        value: "required",
        align: "right",
        width: "15%",
    },
    {
        text: "stock",
        value: "stock",
        align: "right",
        width: "15%",
    },
]